// @ts-nocheck
import { Carousel } from "primereact/carousel";
import styles from "./ModalitiesCarousel.module.css";

import React, { useState } from "react";
import { Button } from "primereact/button";
import InfoDialog from "../InfoDialog/InfoDialog";
import modalities from "../../assets/json/modalitiesContent";
import { responsiveOptions } from "../../utils";

const ModalitiesCarousel = () => {
  const [visible, setVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const itemTemplate = (item) => {
    return (
      <div className={`${styles.carouselItem} defaultLift`}>
        <div
          className={styles.bg}
          style={{ backgroundImage: `url(${item.image})` }}
        />

        <div className={styles.contentWrapper}>
          <img
            src={item.image}
            alt={item.title}
            className={styles.carouselImg}
          />

          <div className={styles.carouselContent}>
            <h3>{item.title}</h3>

            <div className={styles.info}>
              <p>
                <i className="pi pi-calendar" />
                {item.date}
              </p>
              <p>
                <i className="pi pi-clock" />
                {item.time}
              </p>
              <p>
                <i className="pi pi-map-marker" />
                {item.location}
              </p>
              <hr className="separator" />
            </div>

            <Button
              icon="pi pi-info-circle"
              label="Saiba mais"
              className="transparent-button"
              onClick={() => {
                setSelectedItem(item);
                setVisible(true);
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <InfoDialog
        body={selectedItem}
        visible={visible}
        setVisible={setVisible}
      />

      <div className={styles.carouselContainer}>
        <Carousel
          value={modalities}
          numVisible={3}
          numScroll={1}
          itemTemplate={itemTemplate}
          circular
          autoplayInterval={4000}
          responsiveOptions={responsiveOptions}
          className={styles.carousel}
        />
      </div>
    </>
  );
};

export default ModalitiesCarousel;
